/** @module components/quiz */


/**
 * Model classes that implement this interface can usually be rendered
 * to include some kind of "correctness" hint.
 *
 * There are several [[QuizVisitor]]s that manipulate use of this property.
 * The visual feedback additionally depends on your own CSS styling.
 *
 * @seealso [[ShowCorrectnessOfCorrectAnswersQuizVisitor]]
 * @seealso [[ShowCorrectnessOfGivenAnswersQuizVisitor]]
 * @seealso [[ShowCorrectnessOfNoAnswersQuizVisitor]]
 */
export interface CanShowCorrectness {

    /**
     * If this property is `true`, the view template will by convention
     * add a CSS class `-show-correctness` to some DOM element nodes.
     */
    showCorrectness: boolean;
}


/**
 * Checks whether the given `obj` implements the [[CanShowCorrectness]] interface.
 *
 * @param obj The object to check.
 *
 * @returns `true` if `obj` implements [[CanShowCorrectness]]; `false` otherwise.
 */
export function canShowCorrectness(obj: object): obj is CanShowCorrectness {
    return typeof obj['showCorrectness'] !== 'undefined';
}
